<template>
  <section id="banner">
    <div class="inner">
      <header>
        <h2>Sign In</h2>
      </header>
      <p>You must sign in using a <strong>d2si.io</strong> email prior to use the tool
      </p>
      <footer>
        <ul class="buttons stacked">
          <li>
            <a class="button fit" v-if="isGoogleInitialized" v-on:click="googlesignin">Google Sign-In</a>
            <a class="button fit" v-else><i class="fa fa-spinner fa-spin"></i></a>
          </li>
        </ul>
      </footer>
    </div>
  </section>
</template>

<script>
import { Auth } from 'aws-amplify'
import { EventBus } from '../event-bus/event-bus'

export default {
  name: 'Authenticator',
  data: function () {
    return {
      isGoogleInitialized: false
    }
  },
  mounted () {
    let that = this
    let googleClientId = process.env.GOOGLE_CLIENT_ID

    // Download Google API
    let googleClientApi = document.createElement('script')
    googleClientApi.setAttribute('src', 'https://apis.google.com/js/api:client.js')
    document.head.appendChild(googleClientApi)

    googleClientApi.onreadystatechange = googleClientApi.onload = function () {
      // Init Google auth2 component once library loaded
      window.gapi.load('auth2', () => {
        window.gapi.auth2.init({
          client_id: googleClientId,
          cookiepolicy: 'single_host_origin',
          scope: 'email'
        })
      })
      that.isGoogleInitialized = true
    }
  },
  methods: {
    googlesignin: function () {
      let route = this.$route
      window.gapi.auth2
        .getAuthInstance()
        .signIn()
        .then(
          function (googleUser) {
            /* eslint-disable camelcase */
            const { id_token, expires_at } = googleUser.getAuthResponse()
            const profile = googleUser.getBasicProfile()
            const user = {
              email: profile.getEmail(),
              name: profile.getName()
            }

            // Initiate federated sign-in with Google identity provider
            Auth.federatedSignIn(
              'google',
              {
                token: id_token,
                expires_at: expires_at
              },
              user
            ).then(function () {
              EventBus.$emit('authState', {
                value: 'signedIn',
                redirectPath: route.query.redirect
              })
            })
          },
          function (error) {
            console.log(JSON.stringify(error, undefined, 2))
          }
        )
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Authenticator.vue